import { Mapper } from "../../../../base/utils/mapper";
import { TypeCauseModel } from "../../../../domain/models/consult/type-cause.model";
import { TypeCauseEntity } from "../entities/type-cause.entity";

export class TypeCauseImplementationRepositoryMapper extends Mapper<TypeCauseEntity, TypeCauseModel> {
    mapFrom(param: TypeCauseEntity): TypeCauseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeCauseModel): TypeCauseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}